export const subNavItems = {
    items: [
        {
            title: "Job Search",
            uri: "/advice/job-search",
            children: [
                {
                    title: "Finding a Job",
                    uri: "/advice/finding-a-job"
                },
                {
                    title: "Resumes",
                    uri: "/advice/resumes",
                    children: [
                        {
                            title: "Resume Examples",
                            uri: "/advice/resume-examples"
                        }
                    ]
                },
                {
                    title: "Cover Letters",
                    uri: "/advice/cover-letters"
                },
                {
                    title: "Networking",
                    uri: "/advice/networking"
                },
                {
                    title: "Interviewing",
                    uri: "/advice/interviewing"
                },
                {
                    title: "Job Offer",
                    uri: "/advice/job-offer"
                }
            ]
        },
        {
            title: "Career Paths",
            uri: "/advice/career-paths",
            children: [
                {
                    title: "Exploring Careers",
                    uri: "/advice/exploring-careers",
                    children: [
                        {
                            title: "Careers in Data and Analytics",
                            uri: "/advice/data-science-analytics"
                        },
                        {
                            title: "Careers in Finance",
                            uri: "/advice/finance"
                        },
                        {
                            title: "Careers in Marketing",
                            uri: "/advice/marketing"
                        },
                        {
                            title: "Careers in Sales",
                            uri: "/advice/sales"
                        },
                        {
                            title: "Careers in Software Engineering",
                            uri: "/advice/software-engineering"
                        }
                    ]
                },
                {
                    title: "Career Stories",
                    uri: "/advice/career-stories"
                },
                {
                    title: "Career Change",
                    uri: "/advice/career-change"
                },
                {
                    title: "Training and Development",
                    uri: "/advice/training-development"
                }
            ]
        },
        {
            title: "Succeeding at Work",
            uri: "/advice/succeeding-at-work",
            children: [
                {
                    title: "Work and COVID-19",
                    uri: "/advice/work-and-coronavirus-covid-19"
                },
                {
                    title: "Productivity",
                    uri: "/advice/productivity"
                },
                {
                    title: "Getting Ahead",
                    uri: "/advice/getting-ahead"
                },
                {
                    title: "Work Relationships",
                    uri: "/advice/work-relationships"
                },
                {
                    title: "Work-Life Balance",
                    uri: "/advice/work-life-balance",
                    children: [
                        {
                            title: "Working Parents",
                            uri: "/advice/working-parents"
                        },
                        {
                            title: "Remote Work",
                            uri: "/advice/remote-work"
                        }
                    ]
                },
                {
                    title: "Money",
                    uri: "/advice/money"
                },
                {
                    title: "Changing Jobs",
                    uri: "/advice/changing-jobs"
                },
                {
                    title: "Management",
                    uri: "/advice/management"
                },
                {
                    title: "Break Room",
                    uri: "/advice/break-room"
                }
            ]
        },
        {
            title: "Diversity and Inclusion",
            uri: "/advice/diversity-inclusion",
            children: [
                {
                    title: "Anti-Racism at Work",
                    uri: "/advice/anti-racism-at-work"
                },
                {
                    title: "LGBTQ at Work",
                    uri: "/advice/lgbtq-at-work"
                },
                {
                    title: "Disability and Work",
                    uri: "/advice/disability-and-work"
                },
                {
                    title: "Gender and Work",
                    uri: "/advice/gender-and-work"
                }
            ]
        },
        {
            title: "More",
            uri: "",
            children: [
                {
                    title: "Videos",
                    uri: "/advice/videos",
                    children: [
                        {
                            title: "Job Search Videos",
                            uri: "/advice/job-search-videos"
                        },
                        {
                            title: "Career Advice Videos",
                            uri: "/advice/career-advice-videos"
                        },
                        {
                            title: "Career Story Videos",
                            uri: "/advice/career-story-videos"
                        },
                        {
                            title: "Company Spotlight Videos",
                            uri: "/advice/company-spotlight-videos"
                        },
                        {
                            title: "Industry Spotlight Videos",
                            uri: "/advice/industry-spotlight-videos"
                        }
                    ]
                },
                {
                    title: "Employer Resources",
                    uri: "/advice/employer-resources"
                }
            ]
        }
    ]
};
